export default "__VITE_ASSET__1yHs27bA__"